import { ValidationError } from "services/sicalcApi/responses/validationErrorResponse"

/**
 * The errors in a ValidationErrorResponse that belong to a field, e.g. a
 * duplicate organization number. Compare the field names without case: the
 * validation filter sends camelCase, but some controllers send PascalCase.
 */
export function getServerFieldErrors(error: any): ValidationError[] {
  const errors = error?.response?.data?.errors

  if (!Array.isArray(errors)) {
    return []
  }

  return errors.filter((validationError: any) =>
    typeof validationError?.field === 'string'
    && validationError.field.length > 0
    && typeof validationError.message === 'string')
}
